//Script for fading in the back-to-top button and scrolling back up when it is clicked
//Source: https://davidwalsh.name/jquery-top-link
(function($) {
  jQuery.fn.topLink = function(settings) {
      settings = jQuery.extend({
          min: 1,
          fadeSpeed: 200
      }, settings);
      return this.each(function() {
          //listen for scroll
          var el = $(this);
          el.hide; //jshint ignore:line
          $(window).scroll(function() {
              if ($(window).scrollTop() >= settings.min) {
                  el.fadeIn(settings.fadeSpeed);
              } else {
                  el.fadeOut(settings.fadeSpeed);
              }
          });
      });
  };

  $(document).ready(function() {
      //set the link
      $('#back-to-top').topLink({
          min: 600,
          fadeSpeed: 500
      });
      //smoothscroll
      $('#back-to-top').click(function(e) {
          e.preventDefault();
          $('html, body').animate({
              scrollTop: 0
          }, 'slow');
      });
  });
})(jQuery);
